var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{attrs:{"api-key":"8h3d59pat4v4vag8nn7d66m1plfzcs7l4gu3mhe6ffmhswvi","init":_vm.tinymce.init},on:{"input":_vm.contentUpdate},model:{value:(_vm.tinymce.content),callback:function ($$v) {_vm.$set(_vm.tinymce, "content", $$v)},expression:"tinymce.content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }